import React from "react";

const CashWallets = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-7">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-theme text-center ">
                  Important Tax Information
                </h1>
                <h4 className=" text-theme text-center ">
                  Applies Only to Cash Reward Withdrawals
                </h4>
                <p className="text-dark text-center opacity-50">
                  TopCoin UK – Transparency, Trust, and Rewards You Can Rely On
                </p>
              </div>
            </div>
            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  At TopCoin UK, your rewards come in three forms:
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    TopCoin Wallets – These track your progress and help you
                    unlock milestone rewards.
                  </li>
                  <li>
                    Reward Cash Wallets – These hold loyalty reward payments
                    that you may be eligible to withdraw.
                  </li>
                  <li>
                    Reward Bonus Wallets – As your TopCoin Wallet grows, your
                    Reward Bonus Wallet may grow alongside it as part of the
                    loyalty programme.
                  </li>
                </ul>
                <div className="bg bg-light-subtle mt-3 text-theme p-3 border rounded-3">
                  {/* <p className="mb-0 small">Please Note:</p> */}
                  <p className="mb-0">
                    When you withdraw money from any Reward Cash Wallet, the
                    amount may be subject to tax under applicable law.
                  </p>
                </div>
                <div className="text-center py-2 mb-0">
                  <p className="text-dark-emphasis">
                    This tax guidance applies only to cash withdrawals, not to
                    TopCoin balances.
                  </p>
                </div>
              </div>
            </div>
            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">
                  All Reward Cash Wallets Are UK-Based
                </h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>
                    All Reward Cash Wallets are held and managed in the UK
                  </li>
                  <li>
                    Any eligible cash reward you withdraw will be paid directly
                    from the UK
                  </li>
                  <li>
                    Taxes may apply depending on your local or UK tax mportant
                    Notes
                  </li>
                  <li>
                    Taxes may apply depending on your local or UK tax mportant
                    Notes
                  </li>
                  <li>
                    They are not an investment, not interest, and not financial
                    returns
                  </li>
                  <li>
                    Reward eligibility is based on programme rules and
                    participation, not on depositing or investing money
                  </li>
                </ul>
              </div>
            </div>
            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h200">
                <h5 className="text-dark-emphasis py-2">Final Guidance</h5>
                <p className="text-dark-emphasis">
                  TopCoin UK does not provide tax advice. Customers are
                  responsible for checking their own tax obligations with HMRC
                  or a qualified professional if needed.
                </p>
                <p className="text-dark-emphasis">
                  TopCoin UK — Transparency, Trust, and Rewards You Can Rely On.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/*  <div class="row justify-content-center ">
          <div className="col-lg-6">
            <p className="text-center text-dark opacity-50">
              Topcoin UK Transparency, Trust, and Rewards You Can Rely On.
            </p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default CashWallets;
